import {
  FormControlLabel as UnstyledFormControlLabel,
  styled,
} from "@mui/material";
import type { ComponentPropsWithRef } from "react";

interface FormControlLabelProps extends ComponentPropsWithRef<
  typeof UnstyledFormControlLabel
> {
  size: "small" | "medium";
}

export const FormControlLabel = styled(UnstyledFormControlLabel, {
  shouldForwardProp: (propName: keyof FormControlLabelProps) =>
    propName !== "size",
})<FormControlLabelProps>(({ theme, size }) =>
  size === "small"
    ? {
        fontSize: theme.typography.fontSizeMd,
      }
    : null,
);
